export const ScreenSizes = {
    sm: '(min-width: 640px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)',
    xl: '(min-width: 1280px)',
    xxl: '(min-width: 1440px)',
    xxxl: '(min-width: 1920px)'
};
